const notificationMixin = {
  methods: {
    displayKRShutdownMessage () {
      if (I18n.siteCountryLs === 'kr') {
        this.$store.commit('setNotification', {
          type: 'error',
          msg: this.$t('notifications.marketShutdownMessage'),
          isSticky: true
        })
      }
    }
  }
}

export {
  notificationMixin
}
